import { render, staticRenderFns } from "./RtcPrivateVideo.vue?vue&type=template&id=38942839"
import script from "./RtcPrivateVideo.vue?vue&type=script&lang=js"
export * from "./RtcPrivateVideo.vue?vue&type=script&lang=js"
import style0 from "./RtcPrivateVideo.vue?vue&type=style&index=0&id=38942839&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports